
<div (window:resize)="onResize($event)" class="context-wrapper" [class.active]="windowIndex() === windowStore.activeWindowIndex()" (click)="onClick()">
  <ng-content />
</div>
